
export default {
    name: 'OrderPillSkeleton',
    setup() {
        return {
        }
    },
}
